module.exports = __webpack_public_path__ + "assets/img/contactus2.621791a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/contactus2.jpg
// module id = 4WEO
// module chunks = 1